module.exports = __webpack_public_path__ + "static/media/unnamed 1.1618fb97.png";